import { type PropsWithChildren } from "react";

import { AthletesRepositoryContext } from "src/contexts/AthletesRepositoryContext";
import { ExercisesRepositoryContext } from "src/contexts/ExercisesRepositoryContext";
import { LabelsRepositoryContext } from "src/contexts/LabelsRepositoryContext";
import { MetricsRepositoryContext } from "src/contexts/MetricsRepositoryContext";
import { ProgramsRepositoryContext } from "src/contexts/ProgramsRepositoryContext";
import { QuestionnairesRepositoryContext } from "src/contexts/QuestionnairesRepositoryContext";
import { StatisticsRepositoryContext } from "src/contexts/StatisticsRepositoryContext";
import { WorkoutsRepositoryContext } from "src/contexts/WorkoutsRepositoryContext";
import { type AthletesRepository } from "src/repositories/athletes/AthletesRepository";
import { type ExercisesRepository } from "src/repositories/exercises/ExercisesRepository";
import { type LabelsRepository } from "src/repositories/labels/LabelsRepository";
import { type MetricsRepository } from "src/repositories/metrics/MetricsRepository";
import { type ProgramsRepository } from "src/repositories/programs/ProgramsRepository";
import { type QuestionnairesRepository } from "src/repositories/questionnaires/QuestionnairesRepository";
import { type StatisticsRepository } from "src/repositories/statistics/StatisticsRepository";
import { type WorkoutsRepository } from "src/repositories/workouts/WorkoutsRepository";

export interface SpaceRepositories {
  athletes: AthletesRepository;
  metrics: MetricsRepository;
  statistics: StatisticsRepository;
  questionnaires: QuestionnairesRepository;
  exercises: ExercisesRepository;
  labels: LabelsRepository;
  programs: ProgramsRepository;
  workouts: WorkoutsRepository;
}

interface SpaceRepositoryProvidersProps extends PropsWithChildren {
  repositories: SpaceRepositories;
}

export function SpaceRepositoryProviders(props: SpaceRepositoryProvidersProps) {
  return (
    <ExercisesRepositoryContext.Provider value={props.repositories.exercises}>
      <LabelsRepositoryContext.Provider value={props.repositories.labels}>
        <ProgramsRepositoryContext.Provider value={props.repositories.programs}>
          <WorkoutsRepositoryContext.Provider
            value={props.repositories.workouts}
          >
            <AthletesRepositoryContext.Provider
              value={props.repositories.athletes}
            >
              <MetricsRepositoryContext.Provider
                value={props.repositories.metrics}
              >
                <StatisticsRepositoryContext.Provider
                  value={props.repositories.statistics}
                >
                  <QuestionnairesRepositoryContext.Provider
                    value={props.repositories.questionnaires}
                  >
                    {props.children}
                  </QuestionnairesRepositoryContext.Provider>
                </StatisticsRepositoryContext.Provider>
              </MetricsRepositoryContext.Provider>
            </AthletesRepositoryContext.Provider>
          </WorkoutsRepositoryContext.Provider>
        </ProgramsRepositoryContext.Provider>
      </LabelsRepositoryContext.Provider>
    </ExercisesRepositoryContext.Provider>
  );
}
